__turbopack_context__.v({
  "callCta": "items-form-block1440px-module-scss-module__uwWaTW__callCta",
  "error": "items-form-block1440px-module-scss-module__uwWaTW__error",
  "errorMessage": "items-form-block1440px-module-scss-module__uwWaTW__errorMessage",
  "errorText": "items-form-block1440px-module-scss-module__uwWaTW__errorText",
  "form": "items-form-block1440px-module-scss-module__uwWaTW__form",
  "formblock": "items-form-block1440px-module-scss-module__uwWaTW__formblock",
  "icon": "items-form-block1440px-module-scss-module__uwWaTW__icon",
  "icon5": "items-form-block1440px-module-scss-module__uwWaTW__icon5",
  "item1": "items-form-block1440px-module-scss-module__uwWaTW__item1",
  "item11": "items-form-block1440px-module-scss-module__uwWaTW__item11",
  "item2": "items-form-block1440px-module-scss-module__uwWaTW__item2",
  "items": "items-form-block1440px-module-scss-module__uwWaTW__items",
  "label": "items-form-block1440px-module-scss-module__uwWaTW__label",
  "leftcol": "items-form-block1440px-module-scss-module__uwWaTW__leftcol",
  "lookingForA": "items-form-block1440px-module-scss-module__uwWaTW__lookingForA",
  "lookingformblock1440px": "items-form-block1440px-module-scss-module__uwWaTW__lookingformblock1440px",
  "rightcol": "items-form-block1440px-module-scss-module__uwWaTW__rightcol",
  "row": "items-form-block1440px-module-scss-module__uwWaTW__row",
  "submitButton": "items-form-block1440px-module-scss-module__uwWaTW__submitButton",
  "tellUsWhat": "items-form-block1440px-module-scss-module__uwWaTW__tellUsWhat",
  "tellUsWhatContainer": "items-form-block1440px-module-scss-module__uwWaTW__tellUsWhatContainer",
  "text": "items-form-block1440px-module-scss-module__uwWaTW__text",
  "text1": "items-form-block1440px-module-scss-module__uwWaTW__text1",
  "text6": "items-form-block1440px-module-scss-module__uwWaTW__text6",
  "textField": "items-form-block1440px-module-scss-module__uwWaTW__textField",
  "wrapper": "items-form-block1440px-module-scss-module__uwWaTW__wrapper",
});
